import React, { useEffect, useState } from 'react';

export default function AchievementNotification ({
    isVisible,
    achievementName,
    achievementDetails,
    onClose
}: {
    isVisible: boolean;
    achievementName: string;
    achievementDetails: string;
    onClose: () => void;
}) {
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (!isVisible) {
            setIsClosing(false);
        }
    }, [isVisible]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 200);
    };

    if (!isVisible) {return null;}

    return (
        <div
            style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: isClosing ? 'translateX(-50%) translateY(-100%)' : 'translateX(-50%) translateY(-50%)',
                zIndex: 10000,
                backgroundColor: '#4CAF50',
                color: 'white',
                padding: '16px 30px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                maxWidth: '400px',
                textAlign: 'center',
                animation: isClosing ? 'none' : 'slideDown 0.3s ease-out',
                border: '2px solid #45a049',
                transition: isClosing ? 'transform 0.2s ease-out, opacity 0.2s ease-out' : 'none',
                opacity: isClosing ? 0 : 1,
            }}
        >
            {/* Close button */}
            <button
                onClick={handleClose}
                style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    fontSize: '18px',
                    cursor: 'pointer',
                    padding: '0',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                }}
                title="Close notification"
            >
                ×
            </button>

            <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>
                🏆 Achievement Unlocked!
            </div>
            <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                {achievementName}
            </div>
            <div style={{ fontSize: '14px', opacity: 0.9 }}>
                {achievementDetails}
            </div>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            transform: translateX(-50%) translateY(-100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(-50%) translateY(0);
                            opacity: 1;
                        }
                    }
                `}
            </style>
        </div>
    );
}
